// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18kQH","top":"styles_top__ENLpE","left":"styles_left__Ad__i","description":"styles_description__1JUNm"};